module.exports = __webpack_public_path__ + "img/banner-prosedur.c8e59f9c.jpg";